export default __webpack_public_path__ + "aa269914cd8ea05e8af221c56b491fd9.svg";